import axiosInstance from './Axios';
interface LoginResponse {
  token_type: string;
  expire_in: number;
  id_token: string;
  access_token: string;
  refresh_token: string;
  default_mfa: boolean;
  enabled_sms: boolean;
  enabled_totp: boolean;
  phone_number: string;
  special_login_permission: boolean;
}
function login(email: string, password: string) {
  return axiosInstance
    .post<LoginResponse>('/login', { email, password })
    .then((response) => response.data);
  // .catch((error) => {
  //   console.log("error", error)
  //   throw error.response.data;
  // });
}

interface LoginSecureResponse {
  error_code: string;
  error_message: string;
}
function loginSecure(otp_code: string, otp_type: string, set_default: boolean) {
  const params = { otp_code, otp_type, set_default };
  return axiosInstance
    .post('/otp-code-verification', params)
    .then<LoginSecureResponse>((response) => response.data);
  // .catch((error) => {
  //   error.response.data;
  // });
}

function sendSecureSMS() {
  return axiosInstance.post('/otp-sms-resend');
}

function logout() {
  //TODO
}

interface ChangePasswordResponse {
  message: string;
}
function forgotPassword(email: string) {
  const params = { email };
  return axiosInstance
    .post<ChangePasswordResponse>('/forgot-password', params)
    .then((response) => response.data);
}

// interface ChangePasswordResponse {
//   // token_type: string;
//   // expire_in: number;
//   // id_token: string;
//   // access_token: string;
//   // refresh_token: string;
//   // mfa: boolean;
//   phone_number: string;
// }

function register(
  first_name: string,
  last_name: string,
  email: string,
  phone: string,
) {
  const params = { first_name, last_name, email, phone };
  return axiosInstance
    .post('/register', params)
    .then((response) => response.data);
}

function changePassword(user_sub: string, password: string) {
  const params = { user_sub, password };
  return axiosInstance
    .post('/create-password', params)
    .then((response) => response.data);
}

function registerVerify(user_sub: string, token: string) {
  const params = { user_sub, token };
  return axiosInstance
    .post('/register-verify', params)
    .then((response) => response.data);
}

interface SendOtpQrResponse {
  qr_code_url: string;
  secret: string;
}
function sendOtpQRCode() {
  return axiosInstance
    .post<SendOtpQrResponse>('/otp-qr-code')
    .then((response) => response.data);
}

interface SendOtpSMSResponse {
  message: string;
}
function sendOtpSMS() {
  return axiosInstance
    .post<SendOtpSMSResponse>('/otp-sms-resend')
    .then((response) => response.data);
}

interface updatePasswordResponse{
  token: string;
  message: string;
}
function updatePassword(user_id: string, password: string, new_password:string) {
  const params = { user_id, old_password:password, new_password:new_password };
  return axiosInstance
    .post<updatePasswordResponse>('/update-password',params)
    .then((response) => response.data);
}

const AuthService = {
  login,
  loginSecure,
  sendSecureSMS,
  logout,
  forgotPassword,
  register,
  registerVerify,
  changePassword,
  sendOtpQRCode,
  sendOtpSMS,
  updatePassword
};

export default AuthService;
